import React, { ReactNode } from 'react'

import { Navigate } from 'react-router-dom'

import Can from './Can'

interface Props {
  perform: string
  permissions?: string[]
  requiredHomeFeature?: Playground.ChildPermission
  unpermittedUserOrigins?: Playground.UserOrigin[]
  no?(props: any): ReactNode
  yes(props: any): ReactNode
}

const CanRoute = (props: Props) => {
  return (
    <Can
      perform={props.perform}
      permissions={props.permissions}
      unpermittedUserOrigins={props.unpermittedUserOrigins}
      yes={() => <>{props.yes(props)}</>}
      no={() => (props.no ? <>{props.no(props)}</> : <Navigate to="/" replace />)}
    />
  )
}

export default CanRoute
